import type { ops as opsEn } from "../en/ops";

export const ops: typeof opsEn = {
  shared: {
    noneOption: "— žádný —",
  },
  countdown: {
    overdue: "{{days}} d po termínu",
    today: "dnes",
    inDays: "{{days}} d",
  },
  flightDeadlines: {
    deposit: "Záloha",
    foc: "Uvolnění FOC",
    ticketing: "Ticketing",
  },
  serviceQueue: {
    title: "Fronta služeb",
    subtitle: "Dodavatelské rezervace napříč objednávkami — zpracovávejte frontu podle lhůt",
    viewMine: "Moje",
    viewUnassigned: "Nepřiřazené",
    viewAll: "Vše",
    unassignedUrgent_one: "{{count}} nepřiřazená se lhůtou ≤ {{days}} d",
    unassignedUrgent_few: "{{count}} nepřiřazené se lhůtou ≤ {{days}} d",
    unassignedUrgent_other: "{{count}} nepřiřazených se lhůtou ≤ {{days}} d",
    searchPlaceholder: "Hledat podle názvu služby…",
    facetKind: "Druh",
    facetDestination: "Destinace",
    facetStatus: "Stav",
    facetSpecialist: "Specialista",
    noDestination: "Bez destinace",
    unassigned: "Nepřiřazeno",
    emptyQueue: "Fronta je prázdná",
    colService: "Služba",
    colOrder: "Objednávka",
    colCost: "Náklad",
    colDeadlines: "Lhůty",
    colStatus: "Stav",
    colSpecialist: "Specialista",
    onDemand: "na vyžádání",
    onDemandTitle:
      "Na vyžádání — vlastní / vždy dostupná služba; potvrzení dodavatele není potřeba",
    confirmBy: "potvrdit {{date}}",
    payBy: "zaplatit {{date}}",
    overdueDays: "po termínu {{days}} d",
    dueToday: "termín dnes",
    dueInDays: "termín za {{days}} d",
    you: "Vy",
    since: "od {{date}}",
    release: "Uvolnit",
    takeOverFrom: "Převzít od: {{name}}",
    confirmTakeOver: "Potvrdit převzetí",
    claimedBy: "Zabráno: {{name}} — převzít?",
    takeOver: "Převzít",
    claim: "Vzít si",
  },
  flightDesk: {
    title: "Letenky",
    subtitle:
      "Skupinové bloky míst po termínech — čerpání, tři lhůty (záloha · FOC · ticketing) a peníze v riziku na neprodaných místech.",
    flightQueue: "Fronta letenek",
    newAllotment: "Nový allotment",
    atRiskPrefix: "Tento týden v riziku:",
    atRiskSuffix_one: "na neprodaných místech v {{count}} bloku s FOC lhůtou v příštích 7 dnech.",
    atRiskSuffix_few:
      "na neprodaných místech ve {{count}} blocích s FOC lhůtou v příštích 7 dnech.",
    atRiskSuffix_other:
      "na neprodaných místech v {{count}} blocích s FOC lhůtou v příštích 7 dnech.",
    empty: "Zatím žádné letecké allotmenty.",
    createFirst: "Vytvořit první blok",
    colDeparture: "Termín",
    colAirlineRoute: "Aerolinka / trasa",
    colSold: "Prodáno",
    colNextDeadline: "Nejbližší lhůta",
    colAction: "Akce",
    colStatus: "Stav",
    colOwner: "Vlastník",
  },
  allotmentEdit: {
    newTitle: "Nový letecký allotment",
    editTitle: "Upravit letecký allotment",
    airline: "Aerolinka *",
    routeLabel: "Trasa / označení *",
    blockPnr: "PNR bloku",
    departure: "Termín",
    seatsTotal: "Míst v bloku",
    pricePerSeat: "Skupinová cena / místo",
    depositAmount: "Výše zálohy",
    depositDeadline: "Lhůta zálohy",
    focCancellation: "FOC storno",
    ticketingDeadline: "Lhůta ticketingu",
    owner: "Vlastník (letenkář)",
    unassignedOption: "— nepřiřazeno —",
  },
  monitoredFlights: {
    title: "Sledované lety",
    subtitle:
      "Živé sledování zpoždění a zrušení po termínech — funguje s allotmentem i bez něj. Kontroluje se automaticky (denně a v den odletu každou hodinu); při zrušení nebo zpoždění 60 minut se založí úkol.",
    direction: {
      outbound: "Tam",
      return: "Zpět",
      other: "Jiný",
    },
    flightNoPlaceholder: "Číslo letu",
    departureOptional: "— termín (volitelné) —",
    watch: "Sledovat",
    empty: "Zatím se nesledují žádné lety.",
    colFlight: "Let",
    colDeparture: "Termín",
    colStatus: "Stav",
    colDelay: "Zpoždění",
    colChecked: "Zkontrolováno",
    onTime: "včas",
    notChecked: "nezkontrolováno",
    checkNow: "Zkontrolovat teď",
    stopWatching: "Přestat sledovat",
  },
  calendar: {
    title: "Kalendář",
    subtitle: "Lhůty a úkoly napříč objednávkami a službami",
    onlyMine: "Jen moje",
    scan: "Skenovat",
    scanTitle: "Spustit sken lhůt teď",
    weekdays: {
      mon: "Po",
      tue: "Út",
      wed: "St",
      thu: "Čt",
      fri: "Pá",
      sat: "So",
      sun: "Ne",
    },
    nothingScheduled: "Nic naplánováno",
    noDueDate: "Bez termínu",
    reopen: "Znovu otevřít",
    markDone: "Označit jako hotové",
  },
  departures: {
    title: "Termíny",
    subtitle: "Nadcházející skupinové termíny — manifest, rooming, sdílené služby a break-even",
    empty: "Žádné nadcházející termíny",
    colTrip: "Zájezd",
    colDates: "Data",
    colGuide: "Průvodce",
    colBooked: "Obsazeno",
    colStatus: "Stav",
    waitlistShort: "+{{count}} náhr.",
    ordersCount_one: "({{count}} objednávka)",
    ordersCount_few: "({{count}} objednávky)",
    ordersCount_other: "({{count}} objednávek)",
    occupancyTitle: "Odvozeno z obsazenosti vs. kapacity",
    openVelin: "Otevřít velín termínu",
  },
  departureDetail: {
    fallbackTitle: "Termín",
    paxAcrossOrders_one: "{{pax}} os. v {{count}} objednávce",
    paxAcrossOrders_few: "{{pax}} os. ve {{count}} objednávkách",
    paxAcrossOrders_other: "{{pax}} os. v {{count}} objednávkách",
    manifestTitle: "Manifest cestujících",
    revealPassports: "Zobrazit pasy",
    hidePassports: "Skrýt pasy",
    manifestEmpty:
      "Zatím žádní účastníci — objeví se, jakmile objednávky doplní údaje cestujících.",
    colName: "Jméno",
    colOrder: "Objednávka",
    colNationality: "Národnost",
    colPassport: "Pas",
    colDietary: "Strava",
    colRoom: "Pokoj",
    leadBadge: "hlavní",
    ordersTitle: "Objednávky",
    paxShort: "{{count}} os.",
    noOrders: "Žádné objednávky.",
    summaryTitle: "Souhrn",
    rowBookedCapacity: "Obsazeno / kapacita",
    rowOrders: "Objednávky",
    rowPayments: "Platby",
    rowServices: "Služby",
    rowCustomizations: "Úpravy na míru",
    liveOrders_one: "{{count}} aktivní",
    liveOrders_few: "{{count}} aktivní",
    liveOrders_other: "{{count}} aktivních",
    cancelledOrders_one: "{{count}} zrušená",
    cancelledOrders_few: "{{count}} zrušené",
    cancelledOrders_other: "{{count}} zrušených",
    paymentsValue: "{{paid}} zaplaceno · {{deposit}} záloha · {{unpaid}} nezaplaceno",
    overduePayments_one: "{{count}} objednávka po termínu platby",
    overduePayments_few: "{{count}} objednávky po termínu platby",
    overduePayments_other: "{{count}} objednávek po termínu platby",
    servicesValue: "{{ready}} připraveno · {{pending}} čeká",
    servicesToConfirm_one: "{{count}} služba čeká na potvrzení/rezervaci",
    servicesToConfirm_few: "{{count}} služby čekají na potvrzení/rezervaci",
    servicesToConfirm_other: "{{count}} služeb čeká na potvrzení/rezervaci",
    customizationsValue_one: "{{count}} objednávka",
    customizationsValue_few: "{{count}} objednávky",
    customizationsValue_other: "{{count}} objednávek",
    flightBlocksTitle: "Letecké bloky",
    soldRatio: "{{used}}/{{total}} prodáno",
    noDeadline: "lhůta nenastavena",
    atRisk: "−{{amount}} {{currency}} v riziku",
    breakEvenTitle: "Break-even",
    rowRevenue: "Tržby",
    rowCost: "Náklady",
    rowMargin: "Marže",
    rowFixedCost: "Fixní náklady / termín",
    rowAvgRevenue: "Prům. tržba / os.",
    rowVariableCost: "Variabilní náklad / os.",
    rowContribution: "Příspěvek / os.",
    rowBreakEvenPax: "Break-even os.",
    breakEvenValue: "{{value}} (máme {{have}})",
    departureCard: "Termín",
    fieldCapacity: "Kapacita",
    fieldWaitlist: "Náhradníci",
    fieldCode: "Kód",
    fieldMinPax: "Min. počet os. (go/no-go)",
    fieldLifecycle: "Životní cyklus",
    occupancyDerived: "Obsazenost (odvozená)",
    fieldGarant: "Garant (vlastník termínu)",
    inheritGarant: "— dědí se: {{name}} (destinace) —",
    fieldLeadGuide: "Hlavní průvodce (potvrzený)",
    fieldCoGuide: "Druhý průvodce (potvrzený)",
    fieldRoomingNotes: "Poznámky k roomingu",
    roomingPlaceholder: "Pokoj 1: Novák ×2 (dvoulůžkový); Pokoj 2: Nguyen (jednolůžkový)…",
    fieldGuideMessage: "Zpráva průvodce (zobrazí se v portálu po potvrzení průvodce)",
    guideMessagePlaceholder: "Dobrý den, budu vaším průvodcem na tomto zájezdu — těším se na vás…",
    fieldMeetingPoint: "Místo srazu",
    inheritsPlaceholder: "Dědí se: {{value}}",
    meetingPointExample: "např. lobby hotelu Sheraton Hanoi",
    fieldTime: "Čas",
    fieldMeetingNote: "Poznámka ke srazu (pokyny pro tento termín)",
    meetingNotePlaceholder: "Hledejte průvodce s cedulí Go2. Vezměte si pas…",
    fieldInfoMeeting: "Infoschůzka",
    fieldMeetingLink: "Odkaz na schůzku (Google Meet)",
    infoMeetHeld: "Infoschůzka proběhla {{date}}",
    markInfoMeetHeld: "Označit infoschůzku jako proběhlou",
    savedCheck: "Uloženo ✓",
    saveDeparture: "Uložit termín",
    broadcastTitle: "Zpráva cestujícím",
    composeMessage: "Napsat zprávu",
    draftTopicPlaceholder: "Téma pro návrh (např. sraz přesunut do lobby hotelu v 8:00)",
    draftWithAiTitle: "Navrhnout předmět a text pomocí AI",
    draftWithAi: "Navrhnout s AI",
    subjectPlaceholder: "Předmět",
    bodyPlaceholder: "Vaše zpráva všem potvrzeným cestujícím na tomto termínu…",
    sentTo: "Odesláno {{sent}}/{{recipients}} cestujícím.",
  },
  photos: {
    title: "Fotky ze zájezdu",
    photoAlt: "Fotka ze zájezdu",
    processing: "Zpracovává se…",
    restore: "Obnovit",
    hide: "Skrýt",
  },
  guideLink: {
    title: "Aplikace pro průvodce",
    subtitle:
      "Offline-first odkaz na manifest, check-in, incidenty a výdaje. Zobrazí se jen jednou.",
    regenerate: "Vygenerovat odkaz znovu",
    create: "Vytvořit odkaz pro průvodce",
    copyLink: "Kopírovat odkaz",
    openLink: "Otevřít odkaz",
  },
  fulfillment: {
    title: "Připravenost",
    empty: "Na tomto termínu zatím nejsou žádné aktivní objednávky.",
    colOrder: "Objednávka",
    colPax: "Os.",
    colRoom: "Pokoj",
    customizedTitle: "Obsahuje úpravu na míru",
    customBadge: "úprava",
    customBadgeTitle: "Objednávka obsahuje doplněk nebo položku na míru",
    cols: {
      deposit: "Záloha",
      balance: "Doplatek",
      passport: "Pas",
      insurance: "Pojištění",
      visa: "Vízum",
      contract: "Smlouva",
    },
    stateNotRelevant: "{{label}}: zatím není relevantní",
    stateDone: "hotovo",
    stateWarn: "vyžaduje pozornost",
    stateTodo: "zbývá",
    warnDeposit_one: "{{count}} nezaplacená záloha",
    warnDeposit_few: "{{count}} nezaplacené zálohy",
    warnDeposit_other: "{{count}} nezaplacených záloh",
    warnBalance_one: "{{count}} nezaplacený doplatek",
    warnBalance_few: "{{count}} nezaplacené doplatky",
    warnBalance_other: "{{count}} nezaplacených doplatků",
    warnPassport_one: "{{count}} s chybějícím pasem",
    warnPassport_few: "{{count}} s chybějícími pasy",
    warnPassport_other: "{{count}} s chybějícími pasy",
    warnPassportExpiring_one: "{{count}} pas brzy expiruje",
    warnPassportExpiring_few: "{{count}} pasy brzy expirují",
    warnPassportExpiring_other: "{{count}} pasů brzy expiruje",
    warnInsurance_one: "{{count}} bez pojištění",
    warnInsurance_few: "{{count}} bez pojištění",
    warnInsurance_other: "{{count}} bez pojištění",
    warnVisa_one: "{{count}} vízum nevyřízeno",
    warnVisa_few: "{{count}} víza nevyřízena",
    warnVisa_other: "{{count}} víz nevyřízeno",
    warnContract_one: "{{count}} nepodepsaná smlouva",
    warnContract_few: "{{count}} nepodepsané smlouvy",
    warnContract_other: "{{count}} nepodepsaných smluv",
  },
  entryTasks: {
    title: "Vstupní dokumenty",
    subtitle:
      "Příletové karty a víza podávaná za cestující. Štít ukazuje souhlas klienta s podáním z portálu; tečky = připravenost pasu / letu / hotelu / kontaktu.",
    windowUnknown: "Okno neznámé — nastavte ho ve Znalostech zemí",
    windowOpenSince: "Okno OTEVŘENO od {{date}}",
    windowOpens: "Okno se otevře {{date}}",
    readyToFile: "Připraveno k podání",
    missingList: "Chybí: {{list}}",
    dotPassport: "Pas",
    dotFlight: "Let",
    dotHotel: "Hotel",
    dotContact: "Kontakt",
    dotOk: "OK",
    dotMissing: "chybí",
    sheetLoadFailed: "Nepodařilo se načíst podávací tahák",
    groupOf: "skupina po {{max}}",
    autoOn: "auto zapnuto",
    autoOff: "auto vypnuto",
    autoOnTitle:
      "Automatické podávání zapnuto — hodinový cron podává otevřené úkoly v rámci okna (vyžaduje souhlas + globální přepínač)",
    autoOffTitle:
      "Automatické podávání pro tuto zemi vypnuto — zapněte ho ve Znalostech zemí; zkušební běhy fungují i tak",
    copySheet: "Kopírovat podávací tahák",
    openPortalTitle: "Otevřít oficiální portál",
    portal: "Portál",
    colTraveller: "Cestující",
    colOrder: "Objednávka",
    colReady: "Připravenost",
    colArrival: "Přílet",
    colStatus: "Stav",
    colReference: "Reference",
    colAuto: "Auto",
    colQrFile: "QR / soubor",
    consentGiven: "Souhlas s podáním udělen",
    consentMissing: "Souhlas s podáním zatím chybí",
    statusOpen: "otevřeno",
    statusFiled: "podáno",
    statusFailed: "selhalo",
    statusSkipped: "přeskočeno",
    refPlaceholder: "č. potvrzení",
    dryRunTitle:
      "Zkušební běh — vyplní celý formulář portálu, zastaví se před odesláním a uloží kontrolní snímek obrazovky",
    confirmFileNow:
      "Podat příletovou kartu ({{country}}) pro {{name}} TEĎ? Odešle se na vládní portál.",
    timedOutTitle:
      "Předchozí podání vypršelo — ověřte na portálu/QR a pak použijte Opakovat (nepodávejte dvakrát)",
    attemptedTitle:
      "Už proběhl předchozí pokus — ověřte na portálu/QR a pak použijte Opakovat (nepodávejte dvakrát)",
    consentMissingTitle: "Chybí souhlas klienta (portál)",
    autoOffCountryTitle: "Automatické podávání pro tuto zemi vypnuto (Znalosti zemí)",
    fileNowTitle: "Podat teď přes cloudový prohlížeč",
    confirmRetry:
      "Ověřili jste na vládním portálu/QR, že karta ({{country}}) pro {{name}} NENÍ už podaná? Tímto se podání znovu povolí.",
    retryTitle: "Ověřeno na portálu — zrušit blokaci a povolit nové podání",
    queuedLabel: "Ve frontě — obnovte za minutu",
    filedAuto: "Podáno automaticky",
    uploadTitle: "Nahrát QR / potvrzení",
    openArtifact: "Otevřít {{name}}",
    artifactFallback: "soubor",
  },
};
